import Inlet    from './Pipe/Inlet';
import Outlet   from './Pipe/Outlet';
import Provider from './Pipe/Provider';

export default {
  Inlet,
  Outlet,
  Provider
}
